<div class="sub-menu-root-container util-menu-root-container"
    [style.width]="show ? 'var(--left-side-optionbar-width)' : '25px'">
    <div class="menu-list-container">
        <!-- Masters List -->


        <mat-list-item class="mat-list-item" routerLink="/utility/sync-queue" [routerLinkActive]="['is-active']"
            (click)="resetState()" [matTooltip]="!show ? 'Sync Queue' : ''" matTooltipPosition="right"
            matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/syn-error.svg">
                <span class="master-title" style="word-wrap: break-word;"> Sync Queue

                </span>
            </div>
        </mat-list-item>
        <!-- <mat-list-item class="mat-list-item" routerLink="/under-construction" [routerLinkActive]="['is-active']"
            [matTooltip]="!show ? 'Publish Data' : ''" matTooltipPosition="right" matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/publish-data.svg">
                <span class="master-title"> Publish Data</span>
            </div>
        </mat-list-item> -->
        <!-- <mat-list-item class="mat-list-item" routerLink="/under-construction" [routerLinkActive]="['is-active']"
            [matTooltip]="!show ? 'Sale Items Bulk Update' : ''" matTooltipPosition="right"
            matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/sale-item-bulk-update.svg">
                <span class="master-title"> Sale Items Bulk Update
                </span>
            </div>
        </mat-list-item> -->
        <mat-list-item *ngIf="userData?.user_type === 'HQ' && hasAccess('terminal-sync-log')" class="mat-list-item"
            routerLink="/utility/terminal-sync-log" [routerLinkActive]="['is-active']" (click)="resetState()"
            [matTooltip]="!show ? 'Terminal Sync' : ''" matTooltipPosition="right" matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/pos-sync-log.svg">
                <span class="master-title">Terminal Sync

                </span>
            </div>
        </mat-list-item>
        <mat-list-item *ngIf="userData?.user_type === 'HQ' && hasAccess('updater')" class="mat-list-item"
            routerLink="/utility/updater" [routerLinkActive]="['is-active']" (click)="resetState()"
            [matTooltip]="!show ? 'POS Updater' : ''" matTooltipPosition="right" matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/updater.svg">
                <span class="master-title">POS Updater

                </span>
            </div>
        </mat-list-item>
        <mat-list-item *ngIf="userData?.user_type === 'HQ' && hasAccess('ads-setting')" class="mat-list-item"
            routerLink="/utility/ads-setting" [routerLinkActive]="['is-active']" (click)="resetState()"
            [matTooltip]="!show ? 'Ads Setting' : ''" matTooltipPosition="right" matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/ads-settings.svg">
                <span class="master-title">Ads Setting

                </span>
            </div>
        </mat-list-item>

    </div>
</div>